<div class="smart-repetition-list">
  <ng-container *ngFor="let folder of courses">
    <div *ngIf="folder && folder.learnsets && folder.learnsets.length > 0" class="list">
      
      <div class="folder-row">
        <span class="folder-name">{{folder.name}}</span>
        <span class="folder-total-count">
          <tabler-icon name="repeat"></tabler-icon>
          <span>{{folder.openCards}} Karten</span>
        </span>
      </div>

      <div *ngFor="let learnset of folder.learnsets" (click)="handleLearnsetClick(learnset.id!)">
        <div class="divider"></div>
        <div class="learnset-row">
          <tabler-icon name="cards"></tabler-icon>
          <span class="learnset-name">{{learnset.name}}</span>
          <button class="repeat-all" (click)="$event.stopPropagation(); handleLearnLearnsetClick(learnset.id!)">
            <tabler-icon name="repeat"></tabler-icon>
            <span>{{learnset.openCards}} wiederholen</span>
          </button>
        </div>
      </div>

    </div>
  </ng-container>
</div>

<!-- Learn Options -->
<app-bottom-dialog [isVisible]="showLearnOptions" [title]="'Karten wiederholen'" (actionCancelled)="showLearnOptions = false">
  <app-action-buttons [buttonsList]="learnOptionsList" (actionClicked)="handleLearnOptionClick($event)"></app-action-buttons>
</app-bottom-dialog>